import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Info = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.711c.733 0 1.327.595 1.327 1.33v29.63a1.328 1.328 0 1 1-2.654 0V13.04c0-.735.594-1.33 1.327-1.33Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22 4.68c.924 0 1.673-.75 1.673-1.676A1.674 1.674 0 1 0 22 4.68Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2.659a.345.345 0 1 0 0 .69.345.345 0 0 0 0-.69Zm-3 .345A3.002 3.002 0 0 1 22 0c1.657 0 3 1.345 3 3.004a3.002 3.002 0 0 1-3 3.004c-1.657 0-3-1.345-3-3.004ZM22 11.727c.7 0 1.3.601 1.3 1.303v29.667c0 .702-.6 1.303-1.3 1.303-.7 0-1.3-.601-1.3-1.303V13.03c0-.702.6-1.303 1.3-1.303Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 3.007c0 1.704-1.3 3.007-3 3.007s-3-1.404-3-3.007C19 1.303 20.3 0 22 0s3 1.303 3 3.007Z"
  }));
});
Info.displayName = 'Info';
Info.defaultProps = {
  'aria-label': 'Info'
};
export default Info;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Info.js
// module id = 3189
// module chunks = 11